<template>
<div class="assets-widget" @click.stop="openLink()">
  <div class="assets-widget__title">
    {{this.$t(title)}}
  </div>
  <v-divider />
  <div class="assets-widget__data">
    <div v-if="hideDetails" class="assets-widget__data__no-details">
      <div v-if="hasSelected" class="assets-widget__split">
        <div class="assets-widget__split__item">
          <div class="assets-widget__split__value">{{data}}</div>
          <div class="assets-widget__split__label">{{$t('dashboard.assets.widget.label.total')}}</div>
        </div>
        <div class="assets-widget__split__divider" />
        <div class="assets-widget__split__item assets-widget__split__item--selected">
          <div class="assets-widget__split__value">{{selected}}</div>
          <div class="assets-widget__split__label">{{$t('dashboard.assets.widget.label.selected')}}</div>
        </div>
      </div>
      <information-widget-cell
        v-else
        :value="data"
        title=""
      />
    </div>
    <div v-else class="assets-widget__data__has-details">
      <information-widget-cell
        :title="subtitle"
        :value="formattedData"
        fit-to-width
      />
      <delta-widget-cell
        :value="delta"
      />
    </div>
  </div>
</div>
</template>

<script>

import InformationWidgetCell from '@/components/Dashboard/InformationWidgetCell.vue';
import DeltaWidgetCell from '@/components/Dashboard/DeltaWidgetCell.vue';

export default {
  name: 'AssetsWidget',
  components: { DeltaWidgetCell, InformationWidgetCell },
  props: {
    data: {
      type: String,
      required: true,
    },
    delta: {
      type: Number,
      required: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    url: {
      required: false,
    },
    noData: {
      required: false,
      type: Boolean,
      default: false,
    },
    selected: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    hasSelected() {
      return this.selected !== null;
    },
    formattedData() {
      return this.noData ? this.$t('no.data.dashboard.stats') : this.data;
    },
  },
  methods: {
    openLink() {
      if (this.url) {
        this.$router.push(this.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.assets-widget{
  min-width: rem(150);
  min-height: rem(205);
  max-height: rem(205);
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  border-radius: $radius-md;
  background-color: var(--bg-widget);
  &__title{
    color: var(--text-secondary);
    font-family: $font-family-regular;
    font-size: rem(12);
    padding: rem(20) rem(25) 0;
    text-transform: uppercase;
    margin-bottom: rem(7);
    letter-spacing: rem(1.1);
    line-height: rem(15);
  }
  &__data{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-height: rem(155);
    &__no-details{
      max-height: rem(155);
      text-align: center;
      flex-grow: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
    &__has-details{
      display: flex;
      flex-direction: column;
      padding-left: rem(25);
      .info-widget-cell{
        margin-bottom: rem(17);
      }
    }
  }
  &__split{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $space-4;
    margin-top: rem(-15);
    &__item{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: var(--text-primary);
      &--selected{
        color: var(--brand-primary);
      }
    }
    &__value{
      font-family: $font-family-black;
      font-size: $font-size-5xl;
      font-weight: 900;
      line-height: rem(46);
      white-space: nowrap;
    }
    &__label{
      color: var(--text-primary);
      font-family: $font-family-regular;
      font-size: $font-size-sm;
      letter-spacing: $letter-spacing-normal;
      line-height: $line-height-snug;
    }
    &__divider{
      align-self: stretch;
      width: 1px;
      margin: $space-2 0;
      background-color: var(--border-primary);
    }
  }
  &:hover {
    cursor: pointer;
  }
}

</style>
<style lang="scss">
@import '~@/assets/styles/design-system';
.assets-widget {
  .v-divider {
    margin-left: rem(25) !important;
    margin-right: rem(25) !important;
    margin-bottom: rem(15);
  }
  .assets-widget__data__no-details{
    .info-widget-cell__data{
      font-family: $font-family-black;
      font-size: rem(41);
      font-weight: 900;
      letter-spacing: 0;
      line-height: rem(50);
      margin-top: rem(-25);
      margin-left: rem(15);
    }
  }
}
</style>
